import React, {Fragment, useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {Card, Col, Descriptions, Divider, Form, Input, message, Popconfirm, Row, Space} from "antd";
import {useHistory} from "react-router-dom";
import {useParams} from "react-router";
import {useRequest} from "ahooks";
import * as api from "../../../../apis/platforms/admin/financeReceipt"
import withAuth from "../../../../utils/withAuth";
import ProfileTitle from "../../../../components/ProfileTitle";
import dayjs from "dayjs";
import {Decimal} from "decimal.js";

const WriteOffFragment = withAuth('receiptWriteOff', Fragment)
const SettlementFragment = withAuth('settlement', Popconfirm)
const CancelSettlementFragment = withAuth('settlement', Popconfirm)

export default function FinanceReceiptDetail() {

    const history = useHistory()
    const {id} = useParams<any>()
    const [receiptDetail, setReceiptDetail] = useState<any>()

    useEffect(() => {
        if (id) {
            getReceiptDetail(id)
        }
    }, [])

    const {run: getReceiptDetail} = useRequest(api.getFinanceReceiptDetail, {
        manual: true,
        onSuccess: (res) => {
            setReceiptDetail(res.data.data)
        }
    })

    const {run: doManualSettlement} = useRequest(api.manualSettlement, {
        manual: true,
        onSuccess: (res) => {
            getReceiptDetail(id)
            message.success('操作成功')
        }
    })

    return (
        <PageHeaderLayout>
            <Card title={receiptDetail && receiptDetail.receiptNo} extra={
                <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    {receiptDetail && !receiptDetail.manualSettlement && <WriteOffFragment>
                        <a onClick={() => history.push(`/finance/receipt/detail/${id}/receiptWriteOffPage/${id}`)}>核销</a>
                    </WriteOffFragment>}
                    {receiptDetail && !receiptDetail.manualSettlement ?
                        <SettlementFragment
                            title="确认结清"
                            description="此操作将立即结清该收款单"
                            onConfirm={() => doManualSettlement(receiptDetail.id)}
                            okText="确认结清"
                            cancelText="取消"
                            placement="bottomRight"
                        >
                            <a>结清</a>
                        </SettlementFragment> :
                        <CancelSettlementFragment
                            title="取消结清"
                            description="此操作将取消结清该收款单"
                            onConfirm={() => doManualSettlement(receiptDetail.id)}
                            okText="取消结清"
                            cancelText="取消"
                            placement="bottomRight"
                        >
                            <a>取消结清</a>
                        </CancelSettlementFragment>

                    }
                    <a onClick={() => history.goBack()}>返回</a>
                </Space>
            }>
                {receiptDetail && (
                    <Descriptions size={'middle'} bordered title="收款信息" column={3}>
                        <Descriptions.Item label="收款编号">{receiptDetail.receiptNo}</Descriptions.Item>
                        <Descriptions.Item label="客户">{receiptDetail.dealerName}</Descriptions.Item>
                        <Descriptions.Item label="收款信息">{receiptDetail.paymentDesc}</Descriptions.Item>
                        <Descriptions.Item label="收款金额">{receiptDetail.receiptAmount}</Descriptions.Item>
                        <Descriptions.Item label="核销金额">
                            {receiptDetail.receiptWriteOffAmountTotal}
                        </Descriptions.Item>
                        <Descriptions.Item label="未核销金额">
                            {Decimal.sub(receiptDetail.receiptAmount, receiptDetail.receiptWriteOffAmountTotal).toString()}
                        </Descriptions.Item>
                        <Descriptions.Item label="银行流水号">{receiptDetail.bankSn}</Descriptions.Item>
                        <Descriptions.Item label="付款银行">{receiptDetail.bank}</Descriptions.Item>
                        <Descriptions.Item label="付款帐户">{receiptDetail.bankAccount}</Descriptions.Item>
                        <Descriptions.Item label="币种">{receiptDetail.currency}</Descriptions.Item>
                        <Descriptions.Item label="汇率">{receiptDetail.exchangeRate}</Descriptions.Item>
                        <Descriptions.Item label="人民币金额">{receiptDetail.receiptAmountCny}</Descriptions.Item>
                        <Descriptions.Item label="单据类型">
                            {receiptDetail.receiptType === 0 ? '货款' : '退货单款'}
                        </Descriptions.Item>
                        <Descriptions.Item label="核销状态" span={2}>
                            {receiptDetail.manualSettlement ? '已结清' : receiptDetail.writeOffStatus === 0 ? '未核销' : receiptDetail.writeOffStatus === 10 ? '部分核销' : '已核销'}
                        </Descriptions.Item>
                        <Descriptions.Item label="付款说明" span={3}>{receiptDetail.paymentDesc}</Descriptions.Item>
                    </Descriptions>
                )}
                <div style={{marginTop: 20, marginBottom: 20}}>
                    <ProfileTitle>核销列表</ProfileTitle>
                    <table
                        style={{
                            width: '100%',
                            textAlign: "center",
                            borderCollapse: 'collapse',
                            borderColor: 'rgba(5, 5, 5, 0.06)'
                        }}
                        border={1}
                        cellSpacing={0} cellPadding={0}>
                        <thead>
                        <tr style={{backgroundColor: 'rgba(0, 0, 0, 0.02)', color: 'rgba(0, 0, 0, 0.65)', height: 40}}>
                            <td width={'20%'}>核销单号</td>
                            <td width={'20%'}>核销日期</td>
                            <td width={'20%'}>核销金额</td>
                            <td width={'20%'}>状态</td>
                            <td width={'20%'}>操作</td>
                        </tr>
                        </thead>
                        <tbody>
                        {receiptDetail && receiptDetail.writeOffs.map((item: any) => {
                            return (
                                <tr style={{height: 40}}>
                                    <td>{item.writeOffNo}</td>
                                    <td>{dayjs(item.writeOffDate).format('ll')}</td>
                                    <td>{item.writeOffAmountTotal}</td>
                                    <td>{item.status === 0 ? '未审核' : '已审核'}</td>
                                    <td><a onClick={() => history.push(`/finance/writeOff/detail/${item.id}`)}>详情</a>
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </Card>
        </PageHeaderLayout>
    )
}